export function smoothFocus(
  elementIdOrClass: string,
  offset: number,
  scrollToElementId?: string,
  delay?: number,
  shouldScroll?: boolean
) {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  if (offset === undefined) offset = 0;
  if (delay === undefined) delay = 1500;
  if (shouldScroll === undefined) shouldScroll = true;

  const focusElement = document.getElementById(elementIdOrClass) || document.querySelector(`.${elementIdOrClass}`);
  const scrollToElement = (scrollToElementId ? document.getElementById(scrollToElementId) : focusElement)!;

  if (shouldScroll) {
    scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    scrollToElement.scrollTop += offset;
  } else {
    // If should scroll is false, set page scroll without animation to ensure elements
    // that are focused appear on screen on mobile web.

    const defaultOffset = offset > 0 ? offset : 100;
    const elementTopOffset = scrollToElement.getBoundingClientRect().top;
    const elementScrollTop = window.pageYOffset + elementTopOffset - defaultOffset;
    const windowBottomOffset = window.innerHeight - defaultOffset;
    const isElementNotInView = elementTopOffset < defaultOffset || elementTopOffset > windowBottomOffset;

    if (isElementNotInView) {
      window.scroll({ left: 0, top: elementScrollTop, behavior: 'auto' });
    }
  }

  setTimeout(() => {
    focusElement?.focus();
  }, delay);
}
